import React from 'react';
import {
    Routes,
    Route
} from "react-router-dom";
import Login from './Pages/Authentication/Login';
import Registration from './Pages/Authentication/Registration';
import useToken from "./hooks/useToken";
import useRole from './hooks/useRole';

import { HomeEmployer } from './Pages/HomeEmployer';
import { FillProfileStudent1 } from './Pages/FillProfile/FillProfileStudent1';
import { FillProfileStudent2 } from './Pages/FillProfile/FillProfileStudent2';
import { FillProfileStudent3 } from './Pages/FillProfile/FillProfileStudent3';
import { FillProfileEmployer1 } from './Pages/FillProfile/FillProfileEmployer1';
import { FillProfileEmployer2 } from './Pages/FillProfile/FillProfileEmployer2';
import { FillProfileEmployer3 } from './Pages/FillProfile/FillProfileEmployer3';
import { CandidatesForManager } from './Pages/Candidates/CandidatesForManager';
import { CandidatesForNotAuthorized } from './Pages/Candidates/CandidatesForNotAuthorized';
import { EmployerEvents } from './Pages/EmployerEvents';
import { CreateVacancyPage } from './Pages/CreateVacancy';
import { StudentPersonalAccount } from "./Pages/StudentPersonalAccount";
import { StudentInfoEdit } from "./Pages/StudentInfoEdit";
import { StudentReplies } from "./Pages/StudentReplies";
import { StudentEvents } from "./Pages/StudentEvents";
import { StudentVacancies } from "./Pages/Vacancies/StudentVacancies";
import { VacanciesForNotAuthorized } from "./Pages/Vacancies/VacanciesForNotAuthorized";
import { VacanciesByCompany } from './Pages/VacanciesByCompany';
import { EditProfileManager } from './Pages/EditProfileManager';
import { EditProfileCompany } from './Pages/AboutCompany/EditProfileCompany';
import { Rating } from './Pages/Rating';
import ForgotPassword from './Pages/Authentication/ForgotPassword';
import { ReactionsByVacancy } from './Pages/ReactionsByVacancy';
import { PageDoesNotExist } from './Pages/PageDoesNotExist';
import { PrivacyPolicy } from './Pages/Consents/PrivacyPolicy';
import { PersonalData } from './Pages/Consents/PersonalData';
import ConfirmEmail from './Pages/Authentication/ConfirmEmail';
import { StudentAccauntForEmployer } from './Pages/StudentAccountForEmployer';
import { EventEmployer } from './Pages/EventEmployer';
import { EventStudent } from './Pages/EventStudent';
import { CreateEvent } from './Pages/CreateEvent';
import {VacancyEmployer, VacancyNotAuthorized, VacancyStudent} from './Pages/Vacancy';
import NewPassword from './Pages/Authentication/NewPassword';
import LoginWithCode from './Pages/Authentication/LoginWithCode';
import { RegistrationLinks } from './Pages/AdminPages/RegistrationLinks';
import { CreateRegistrationLink } from './Pages/AdminPages/CreateRegistrationLink';
import { UserRole } from './Enums/UserRole';
import { ProfileContacts } from './Pages/AdminPages/ProfileContacts';
import { StudentAccauntForAdmin } from './Pages/AdminPages/StudentAccountForAdmin';
import { AdminVacancies } from './Pages/AdminPages/AdminVacancies';
import { VacancyAdmin } from './Pages/Vacancy/VacancyAdmin';
import { ReactionForAdmin, ReactionForEmployer } from './Pages/Reaction';
import { CompanyPageForStudent } from './Pages/CompanyPage/CompanyPageForStudent';
import { CompanyPageForOtherCompany } from './Pages/CompanyPage/CompanyPageForOtherCompany';
import { CompanyPageForNotAuthorized } from './Pages/CompanyPage/CompanyPageForNotAuthorized';

let pagesForCurrentRole: React.ReactNode;
export const App = () => {
    const { token, setToken } = useToken();
    const { role, setRole } = useRole();

    if (!token) {
        pagesForCurrentRole = <>
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/registration/:codeEmployer" element={<Registration setToken={setToken} setRole={setRole}/>} />
        <Route path="/vacancy" element={<VacancyNotAuthorized />}>
            <Route path=":id" element={<VacancyNotAuthorized />} />
        </Route>
        <Route path="/vacancies" element={<VacanciesForNotAuthorized/>}/>
        <Route path="/candidates" element={<CandidatesForNotAuthorized /> } />
        <Route path="/simpleLogin" element={<LoginWithCode setToken={setToken} setRole={setRole} />} />
        <Route path="/company" element={<CompanyPageForNotAuthorized />} >
            <Route path=":id" />
        </Route>
        <Route path="*" element={<Login setToken={setToken} setRole={setRole}/>} />
    </>
    } else {
        if (role === UserRole.Manager) {
            pagesForCurrentRole = <>
                <Route path="/" element={<HomeEmployer />} />
                <Route path="/fillProfile" element={<FillProfileEmployer1 isCompanyExist={true}/>} />
                <Route path="/fillProfile1" element={<FillProfileEmployer1 />} />
                <Route path="/fillProfile2" element={<FillProfileEmployer2 />} />
                <Route path="/fillProfile3" element={<FillProfileEmployer3 />} />
                <Route path="/candidates" element={<CandidatesForManager /> } />
                {/* <Route path="/events" element={<EmployerEvents/>}/> */}
                <Route path="/ratingStudents" element={<Rating />} />
                <Route path="/createVacancy" element={<CreateVacancyPage /> } />
                <Route path="/vacanciesByCompany" element={<VacanciesByCompany />} />
                <Route path="/createVacancy" element={<CreateVacancyPage /> }>
                    <Route path=":id" element={<CreateVacancyPage />} />
                </Route>
                <Route path="/vacancy" element={<VacancyEmployer />}>
                    <Route path=":id" element={<VacancyEmployer />} />
                </Route>
                <Route path="/reactionsByVacancy" element={<ReactionsByVacancy />}>
                    <Route path=":id" element={<ReactionsByVacancy />} />
                </Route>
                <Route path="/reaction" element={<ReactionForEmployer />}>
                    <Route path=":id" element={<ReactionForEmployer />} />
                </Route>
                <Route path="/editProfileManager" element={<EditProfileManager />} />
                <Route path="/editProfileCompany" element={<EditProfileCompany />} />
                <Route path="/company" element={<CompanyPageForOtherCompany />} >
                    <Route path=":id" />
                </Route>
                <Route path="/candidate" element={<StudentAccauntForEmployer /> } >
                    <Route path=":id" element={<StudentAccauntForEmployer />} />
                </Route>
                {/* <Route path="/event" element={<EventEmployer /> } >
                    <Route path=":id" element={<EventEmployer />} />
                </Route>
                <Route path="/createEvent" element={<CreateEvent />} />
                <Route path="/createEvent" element={<CreateEvent />}>
                    <Route path=":id" element={<CreateEvent />} />
                </Route> */}
                <Route path="*" element={<PageDoesNotExist />} />
            </>
        } else if (role === UserRole.Student) {
            pagesForCurrentRole = <>
                <Route path="/" element={<StudentVacancies/>}/>
                <Route path="/fillProfile1" element={<FillProfileStudent1 />} />
                <Route path="/fillProfile2" element={<FillProfileStudent2 />} />
                <Route path="/fillProfile3" element={<FillProfileStudent3 />} />
                <Route path="/home" element={<StudentPersonalAccount/>}/>
                <Route path="/edit" element={<StudentInfoEdit/>}/>
                <Route path="/replies" element={<StudentReplies/>}/>
                <Route path="/events" element={<StudentEvents/>}/>
                <Route path="/vacancy" element={<VacancyStudent />}>
                    <Route path=":id" element={<VacancyStudent />} />
                </Route>
                <Route path="/company" element={<CompanyPageForStudent />} >
                    <Route path=":id" />
                </Route>
                <Route path="/event" element={<EventStudent /> } >
                    <Route path=":id" element={<EventStudent />} />
                </Route>
                <Route path="*" element={<PageDoesNotExist />} />
            </>
        } else if (role === UserRole.Admin) {
            pagesForCurrentRole = <>
                <Route path="/registrationLinks" element={<RegistrationLinks/>} />
                <Route path="/createRegistrationLink" element={<CreateRegistrationLink />} />
                <Route path="/contacts" element={<ProfileContacts />} />
                <Route path="/candidate" element={<StudentAccauntForAdmin />} >
                    <Route path=":id" element={<StudentAccauntForAdmin />} />
                </Route>
                <Route path="/vacancies" element={<AdminVacancies/>}/>
                <Route path="/vacancy" element={<VacancyAdmin />}>
                    <Route path=":id" element={<VacancyAdmin />} />
                </Route>
                <Route path="/reaction" element={<ReactionForAdmin />}>
                    <Route path=":id" element={<ReactionForAdmin />} />
                </Route>
                <Route path="*" element={<RegistrationLinks />} />
            </>
        }
    }
    return (
        <>
            <Routes>
                <Route path="/confirmLink" element={<ConfirmEmail /> } >
                    <Route path=":confirmString" />
                </Route>
                <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
                <Route path="/personalData" element={<PersonalData />} />
                <Route path="/newPassword/:code" element={<NewPassword/>} /> 
                {pagesForCurrentRole}
            </Routes>
        </>
    )
}

export default App;
